export default "__VITE_ASSET__DAYpRvUd__"